exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles--dtPicker__2zj59{width:100%;cursor:pointer}\n", ""]);

// exports
exports.locals = {
	"dtPicker": "styles--dtPicker__2zj59"
};